import NoDataComponent from "./../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const employer_pocs_no_data = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Employers POCs"
      subheaderinfo="Employers POCs will appear here"
    />
  );
};

export default employer_pocs_no_data;